import React from 'react';
import classnames from 'classnames';
import { string } from 'prop-types';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { ELEMENT_NAMES } from '../../../../utils/biEvents/constants';
import { clickOnExpertCardEvent } from '../../../../utils/biEvents/events';
import { useExpertCardContext } from '../../../../contexts';
import { getOpenExpertPageLinkTarget } from '../../utils';
import propTypes from '../types';

import './index.scss';

/**
 * A component that describes user avatar.
 */
const UserAvatar = ({ source, containerClassName, onClick }) => {
    const { cardImpressionId, seller, freelancerUrl, componentName, isAgencyCard } = useExpertCardContext();
    const { username, avatarUrl } = seller;

    return (
        <a
            className={classnames('seller-avatar-wrapper', containerClassName)}
            target={getOpenExpertPageLinkTarget()}
            href={freelancerUrl}
            onClick={(e) => {
                clickOnExpertCardEvent({
                    pageName: source,
                    elementName: ELEMENT_NAMES.SELLER_AVATAR,
                    impressionId: cardImpressionId,
                    componentName,
                    seller,
                });
                if (onClick) {
                    e.preventDefault();
                    onClick(e);
                }
            }}
        >
            <Avatar size="xl" username={username} shape={isAgencyCard ? 'square' : 'circle'}>
                <AvatarImage src={avatarUrl} />
            </Avatar>
        </a>
    );
};

UserAvatar.propTypes = {
    source: propTypes.source,
    containerClassName: string,
    onClick: propTypes.onClick,
};

export { UserAvatar };
